module.exports = __webpack_public_path__ + "img/item9.761023a2.png";